<div class="container-fluid">
  <div class="card border-light shadow-sm">
    <div class="row">
      <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
      </div>
    </div>

    
  <div class="col-sm-12">

    <div class="row">
    <div class="col-sm-12">
      <div class="container">
        <form>
  
          <div class="row">
            <div *ngIf="status==1" class="col-50" style="text-align: center;">
              <h4>PAYMENT COMPLETE <i class="fa fa-check-square-o" style="color: green; font-size: 60px; vertical-align: middle;" aria-hidden="true"></i></h4>
              <label for="fname"><i class="fa fa-user"></i> Reference: {{paymentRef}}</label>
            </div>

            <div *ngIf="status == 0 || (status >=2 && status<=4)" class="col-50" style="text-align: center;">
              <h4>PAYMENT FAILED <i class="fa fa-times" style="color: red; font-size: 60px; vertical-align: middle;" aria-hidden="true"></i></h4>
              <label for="fname"><i class="fa fa-user"></i> Reason: {{statusDesc}}</label>
            </div>

            <div *ngIf="status >= 5" class="col-50" style="text-align: center;">
              <h4>PAYMENT IN PROGRESS <i class="fa-solid fa-bars-progress" style="color: orange; font-size: 60px; vertical-align: middle;" aria-hidden="true"></i></h4>
              <label for="fname"><i class="fa fa-user"></i> Reason: {{statusDesc}}</label>
            </div>
  
           
  
          </div>
          <button class="btn btn-md m-clr pull-right hd-btn"  (click)="backToTab()"><i class="fa fa-times" ></i> Close</button>
          <!-- <input type="submit" value="Continue to checkout" class="btn"> -->
        </form>
      </div>
    </div>
    </div>  

    <div class="col-md-6">
 
    
  </div>
   
  </div>
</div>

